import * as R from 'ramda';

export const isOpen = ({ cancelOrder }) => cancelOrder.showing;
export const isSubmiting = ({ cancelOrder }) => cancelOrder.submiting;
export const getId = ({ cancelOrder }) => R.path(['order', '_id'], cancelOrder);
